import { useCallback, useState } from "react";

export const usePopoverActions = () => {
  const [popoverElementAnchor, setPopoverElementAnchor] =
    useState<HTMLButtonElement | null>(null);

  const openPopover = useCallback(
    (event: React.MouseEvent<HTMLButtonElement>) => {
      event.stopPropagation();
      setPopoverElementAnchor(event.currentTarget);
    },
    [setPopoverElementAnchor],
  );

  const closePopover = useCallback(() => {
    setPopoverElementAnchor(null);
  }, [setPopoverElementAnchor]);

  return {
    closePopover,
    openPopover,
    popoverElementAnchor,
  };
};
